import { Injectable, signal } from '@angular/core';
import { IDashboardDto } from '../interfaces/dtos/client/IDashboardDto';

@Injectable({
  providedIn: 'root'
})
export class ClientDashboardAuthService {
  public CurrentDashboard = signal<IDashboardDto | undefined>(undefined);

  public GetCurrentDashboardBaseViewUrl(): string{
    return `/client/dashboards/${this.CurrentDashboard()!.Id}`
  }
}
